<template>
  <header
      style="width: 100%;height: auto;margin-bottom:0;">
    <div
        style="position: fixed;top:0;z-index: 99;width: 100%;height: 102px;">
      <div
          style="width: 100%;display: flex;flex-direction: column;align-items: center;box-shadow: 0 2px 2px 0 rgba(0,0,0,0.10);">
        <div
            style="background: white;width: 100%;height: auto;display: flex;justify-content: center;">
          <div style="width: 1200px;height: auto;display: flex;justify-content: space-between;padding-right: 4px;">
            <div style="height: 100%;display: flex;align-items: flex-end;width: 50%;padding: 4px;">
              <img style="width: 100%;/*height: 100%;*/cursor: pointer;" :src="$language === 'ZH' ? logoZh : logoEn"
                   @click="$router.push('/')"/>
            </div>
            <div style="padding-top: 16px;display: flex;flex-direction: column;align-items: flex-end;">
              <div
                  style="display:flex;align-items: center;cursor: pointer;font-weight: bold;">
                <img src="../assets/image/headerIcon1.png" style="width: 18px;height: 18px;margin-right: 4px"/>
                <div @click="loginBtn('zs')"
                     style="font-size: 14px;color: #444444;line-height: 22px;">
                  {{ headerLogin1 }}
                </div>
                <img src="../assets/image/headerIcon2.png"
                     style="width: 18px;height: 18px;margin-right: 4px;margin-left: 24px;"/>
                <div @click="loginBtn('gz')"
                     style="font-size: 14px;color: #444444;line-height: 22px;">
                  {{ headerLogin2 }}
                </div> 
                <img src="../assets/image/headerIcon3.png"
                     style="width: 18px;height: 18px;margin-right: 4px;margin-left: 24px;"/>
                <div style="font-size: 14px;line-height: 22px;">
                  <!--                  <span @click="changeLanguage('ZH')" :style="language === 'ZH' ? 'color: #d7000F;' : 'color: #444444;'">{{ headerLanguage1 }}</span>
                                    <span style="padding: 0 2px;color: #444444;">/</span>
                                    <span @click="changeLanguage('EN')" :style="language === 'EN' ? 'color: #d7000F;' : 'color: #444444;'">{{ headerLanguage2 }}</span>-->

                  <a-select
                      ref="select"
                      v-model="language"
                      style="width: 70px"
                      size="small"
                      @change="changeLanguage"
                  >
				    <a-select-option value="ZH">{{ headerLanguage1 }}</a-select-option>
                    <a-select-option value="EN">{{ headerLanguage2 }}</a-select-option>
<!-- 					<a-select-option v-if="$language === 'ZH'" value="EN">EN</a-select-option>
					<a-select-option v-if="$language === 'EN'" value="ZH">中文</a-select-option> -->
<!--                   <a-select-option value="日本語">{{ headerLanguage3 }}</a-select-option> -->
<!--                    <a-select-option value="한국어">{{ headerLanguage4 }}</a-select-option>-->
<!--                    <a-select-option value="ไทย">{{ headerLanguage5 }}</a-select-option>-->
                  </a-select>
                </div> 
                <div @click.stop="searchModalBtn" style="display: flex;align-items: center;margin-left: 24px;">
                  <img src="../assets/image/headerIcon4.png"
                       style="width: 18px;height: 18px;margin-right: 4px;"/>
                  <div style="font-size: 14px;color: #444444;line-height: 22px;">
                    {{ headerSearch }}
                  </div>
                </div>
              </div>
<!--            <div
                  style="height:100%;display:flex;align-items: center;margin-top: -8px;"> -->
		<div style="height:100%;display:flex;align-items: center;margin-top: -8px;">
                <div v-for="(item,index) in menu" :key="index" @mouseover="menuMouseOver(index)"
                     @mouseout="menuMouseOut"
                     style="height: 100%;display:flex;align-items: center;justify-content: center;position: relative;padding-left: 32px;">
                  <div @click="titleClick(index)" class="menuTitle" :style="index === 5 ? 'color: #3DA5FF;':''">
                    {{ item.title }}
                  </div>
                  <div v-show="item.select"
                       style="width: 36px;height: 3px;background-color: #d7000F;border-radius: 3px;position: absolute;bottom: 6px"></div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
      <!--搜索页-->
      <div v-if="searchModal" class="animate-fade-header"
           style="border-top: 2px rgba(0,0,0,0.10) solid;width: 100%;min-height: 330px;background: rgba(255,255,255,0.94);box-shadow: 0 2px 2px 0 rgba(0,0,0,0.10);border-radius: 1px;display: flex;justify-content: center;z-index: 999;"
           @click.stop>
        <div
            style="width: 1200px;height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;position:relative;">
          <div style="width: 600px;margin-top: 12px;">
            <div style="width: 100%;height: 44px;background: #FFFFFF;display: flex;align-items: center;">
              <a-input :placeholder="$t('h.headSearch.PleaseEnterTheContentYouWantToSearch')"
                       style="width: 545px;height: 100%;padding: 10px 12px;border: 1px solid #DDDDDD;border-radius: 4px 0 0 4px;"
                       v-model="nextLevelValue" @pressEnter.stop="handleSearchNextLevelMenu"/>
              <a-button class="customBtn" @click="handleSearchNextLevelMenu"
                        style="width: 55px;height: 100%;border: none;background: #1677FF;border-radius: 0 4px 4px 0;">
                <img src="@/assets/img/search.png" style="width: 24px;height: 24px;"/>
              </a-button>
            </div>
            <div style="margin-top: 16px;display: flex;width: 100%;">
              <div
                  style="width: 120px;font-size: 16px;color: #444444;padding-right: 8px;">
                {{ $t('h.headSearch.PopularSearches') }}：
              </div>
              <div style="font-size: 16px;color: #3DA5FF;">
                <template v-for="(item, index) in hotSearch">
                  <span :key="item.title" style="cursor:pointer;" @click="handleGoMenu(item)">{{ item.title }}</span>
                  <span v-if="index !== hotSearch.length -1" :key="index"> | </span>
                </template>
              </div>
            </div>
            <div
                style="font-size: 18px;color: #d7000F;padding-top: 34px;padding-bottom: 24px">
              {{ $t('h.headSearch.PopularSearchProductCategories') }}
            </div>

            <div>
              <a-button @click="handleClickSearch(item.label)" class="customBtn"
                        v-for="(item,index) in categorySearchList"
                        :key="index"
                        style="height: 32px;margin-bottom: 10px;background: #FFFFFF;border: 1px solid #DDDDDD;border-radius: 4px;font-family: PingFangSC-Regular;font-size: 14px;color: #666666;line-height: 22px;margin-right: 12px;">
                {{ item.label }}
              </a-button>
            </div>
          </div>
          <img @click="searchModal = false" class="customBtn"
               style="position: absolute;top: 30px;right: 0;width: 36px;height: 36px;cursor:pointer;"
               src="@/assets/img/close.png"/>
        </div>
      </div>
      <div v-else>
        <!--二级菜单-->
        <div v-show="showHoverDiv" class="animate-fade-header"
             style="border-top: 2px rgba(0,0,0,0.10) solid;width: 100%;background: rgba(255,255,255,0.94);box-shadow: 0 2px 2px 0 rgba(0,0,0,0.10);border-radius: 1px;display: flex;justify-content: center;z-index: 99;"
             @mouseover="showHoverDiv = true"
             @mouseout="showHoverDiv = false">
          <div style="width: 1100px;padding-top: 20px;margin-left: 60px;padding-bottom: 20px;" class="flex">
            <div class="flex">
              <div>
                <div
                    class="title">
                  {{ menu[1].title }}
                </div>
                <div style="margin-top: 12px;">
                  <div style="white-space: nowrap;" v-for="(item,index) in menu[1].children" :key="index" @click="itemClick(item.path,1,null)"
                       class="subTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div style="margin-left: 100px">
                <div
                    class="title">
                  {{ menu[2].title }}
                </div>
                <div style="margin-top: 12px;">
                  <div v-for="(item,index) in menu[2].children" :key="index"
                       @click="itemClick(item.path,2,item.queryKey)"
                       class="subTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div style="margin-left: 100px;">
                <div
                    class="title">
                  {{ menu[3].title }}
                </div>
                <div style="margin-top: 12px;">
                  <div v-for="(item,index) in menu[3].children" :key="index"
                       @click="itemClick(item.path,3,item.queryKey)"
                       class="subTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div style="margin-left: 100px;">
                <div
                    class="title">
                  {{ menu[4].title }}
                </div>
                <div style="margin-top: 12px;">
                  <div v-for="(item,index) in menu[4].children" :key="index" @click="itemClick(item.path,4,null)"
                       class="subTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div style="margin-left: 100px;">
                <div class="title">
                  {{ menu[5].title }}
                </div>
                <div style="margin-top: 12px;">
                  <div v-for="(item,index) in menu[5].children" :key="index"
                       @click="itemClick(item.path,5,item.queryKey)"
                       class="subTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
            <!--            <div style="height: 160px;" class="flex flex-column align-center justify-center">-->
            <!--              <a-button @click="customMenu('zs')" class="customBtn"-->
            <!--                        style="background: #d7000F;width: 150px;height: 40px;border: none;font-size: 20px;color: #FFFFFF;">-->
            <!--                展位申请-->
            <!--              </a-button>-->
            <!--              <a-button @click="customMenu('gz')" class="customBtn"-->
            <!--                        style="background: #d7000F;width: 150px;height: 40px;border: none;font-size: 20px;color: #FFFFFF;margin-top: 24px;">-->
            <!--                观众预登记-->
            <!--              </a-button>-->
            <!--            </div>-->

          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import message from 'ant-design-vue/es/message';
import {EventBus} from "@/assets/event-bus";
import logoZh from '@/assets/image/header-logo-zh.png'
import logoEn from '@/assets/image/header-logo-en.png'

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  data() {
    return {
      logoZh,
      logoEn,
      nextLevelValue: "",
      showHoverDiv: false,
      searchModal: false,
      headerLogin1: localStorage.getItem('userIdentity') === 'zs' ? this.$t('h.tabName3Item7') : this.$t('h.headerLogin1'),
      headerLogin2: localStorage.getItem('userIdentity') === 'visitor' ? this.$t('h.tabName4Item6') : this.$t('h.headerLogin2'),
      headerSearch: this.$t('h.headerSearch'),
      headerLanguage1: this.$t('h.headerLanguage1'),
      headerLanguage2: this.$t('h.headerLanguage2'),
      headerLanguage3: this.$t('h.headerLanguage3'),
      headerLanguage4: this.$t('h.headerLanguage4'),
      headerLanguage5: this.$t('h.headerLanguage5'),
      language: localStorage.getItem('lang') || 'ZH',
      categorySearchList: [
        {
          label: this.$t('h.Company.companyType1'),
          value: "线缆线材生产与精加工机械Wire and cable production and finishing machinery",
        },
        {
          label: this.$t('h.Company.companyType2'),
          value: "线缆辅助加工Cable auxiliary machining",
        },
        {
          label: this.$t('h.Company.companyType3'),
          value: "线缆光缆用原辅材料Raw and auxiliary materials for cables optical cables",
        },
        {
          label: this.$t('h.Company.companyType4'),
          value: "成品线材及电线电缆Finished wire and wire cable",
        },
        {
          label: this.$t('h.Company.companyType5'),
          value: "测控技术Measurement and control technology",
        },
        {
          label: this.$t('h.Company.companyType6'),
          value: "检测工程Inspection engineering",
        },
        {
          label: this.$t('h.Company.companyType7'),
          value: "相关领域Related field",
        }
      ],
      hotSearch: [
        {
          title: this.$t('h.tabName4ItemItem1'),
          path: "/vistor/register-gz"
        },
        {
          title: this.$t('h.tabName3Item3'),
          path: "/ZwApply"
        },
        {
          title: this.$t('h.tabName4Item2'),
          path: "/vistor/Materials"
        },
        {
          title: this.$t('h.tabName3Item7'),
          path: "/ZsCenter"
        },
        {
          title: this.$t('h.tabName4Item6'),
          path: "/vistor/center"
        },
      ],
      menu: [
        {
          title: this.$t('h.tabName1'),
          select: true,
          path: '/',
          children: []
        },
        {
          title: this.$t('h.tabName2'),
          select: false,
          children: [
            {
              title: this.$t('h.tabName2Item1'),
              path: '/about',
            },
            {
              title: this.$t('h.tabName2Item3'),
              path: '/dynamic',
            },
            {
              title: this.$t('h.tabName2Item5'),
              path: '/transport',
            },
			{
			  title: this.$t('h.tabName2Item8'),
			  path: '/media',
			}
          ]
        },
        {
          title: this.$t('h.tabName3'),
          select: false,
          path: '',
          children: [
            {
              title: this.$t('h.tabName3Item1'),
              path: '/czProcess'
            },
            // {
            //   title: this.$t('h.tabName3Item2'),
            //   path: '/czsList'
            // },
            {
              title: this.$t('h.tabResourceCenter'),
              path: '/resource-center'
            },
            {
              title: this.$t('h.tabName3Item3'),
              path: '/zwApply'
            },
            {
              title: this.$t('h.tabName3Item4'),
              path: '/zsPropagateApply'
            },
            {
              title: localStorage.getItem('userIdentity') === 'zs' ? this.$t('h.tabName3Item7') : this.$t('h.tabName3Item5'),
              path: localStorage.getItem('userIdentity') === 'zs' ? '/zsCenter' : '/zsLogin'
            },
            {
              title: this.$t('h.tabName3Item6'),
              path: '/visa-apply',
              queryKey: '展商'
            }
          ]
        },
        {
          title: this.$t('h.tabName4'),
          select: false,
          path: '',
          children: [
            {
              title: this.$t('h.tabName4Item1'),
              path: '/vistor/register'
            },
            // {
            //   title: this.$t('h.tabName4Item2'),
            //   path: '/vistor/materials'
            // },
            {
              title: this.$t('h.tabResourceCenter'),
              path: '/resource-center'
            },
            {
              title: this.$t('h.tabName4Item3'),
              //path: '/product/home',
			  path: '/product/supplier',
            },
            //{
           //   title: localStorage.getItem('userIdentity') === 'visitor' ? this.$t('h.tabName4Item6') : this.$t('h.tabName4Item4'),
           //   path: localStorage.getItem('userIdentity') === 'visitor' ? '/vistor/center' : '/vistor/login'
           // },
            {
              title: this.$t('h.tabName4Item5'),
              path: '/visa-apply',
              queryKey: '观众'
            }
          ]
        },
        {
          title: this.$t('h.tabName5'),
          select: false,
          path: '',
          children: [
            {
              title: this.$t('h.tabName5Item1'),
              path: '/meet/industry-conference'
            },
            {
              title: this.$t('h.tabName5Item2'),
              path: '/meet/technical-exchange'
            },
            {
              title: this.$t('h.tabName5Item3'),
              path: '/meet/cable-cloud'
            },
            {
              title: this.$t('h.tabName5Item4'),
              path: '/meet/overseas-exhibition'
            },
            // {
            //   title: this.$t('h.tabName5Item5'),
            //   path: '/meet/other'
            // }
          ]
        },
        {
          title: this.$t('h.tabName6'),
          select: false,
          path: '',
          children: [
            {
              title: this.$t('h.tabName6Item1'),
              path: '/product/supplier',
              queryKey: '供应商'
            },
            {
              title: this.$t('h.tabName6Item2'),
              path: '/product/supplier',
              queryKey: '产品'
            },
            {
              title: this.$t('h.tabName6Item3'),
              path: '/product/asktobuy'
            },
            {
              title: this.$t('h.tabName6Item4'),
              path: '/product/release'
            }
          ]
        }
      ],
    }
  },
  created() {
    EventBus.$on('token-invalid', (status) => {
      this.$message.info(this.$t('h.tokenFailed'))
      this.headerLogin1 = this.$t('h.headerLogin1')
      this.headerLogin2 = this.$t('h.headerLogin2')
      this.menu[2].children[4].title = this.$t('h.tabName3Item5')
      this.menu[2].children[4].path = '/zsLogin'
      this.menu[3].children[3].title = this.$t('h.headerLogin2')
      this.menu[3].children[3].path = '/vistor/login'

    });
    EventBus.$on('submenu-selected', (submenu) => {
      this.initMenu(submenu)
    });
    EventBus.$on('login-visitor', (submenu) => {
      this.headerLogin2 = localStorage.getItem('token') ? this.$t('h.tabName4Item6') : this.$t('h.headerLogin2')
    });
    EventBus.$on('handleOperateSearchModal', (submenu) => {
      this.searchModal = false
    });
  },
  methods: {
    handleSearchNextLevelMenu() {
      if (!this.nextLevelValue) {
        this.$message.error(this.$t('h.headSearch.PleaseEnterTheContentYouWantToSearch'))
      } else {
        if (this.categorySearchList.some(item => this.nextLevelValue.trim() === item)) {
          this.handleClickSearch(this.nextLevelValue)
        } else {
          this.$router.push({
            path: "/search",
            query: {
              globalSearch: this.nextLevelValue
            }
          })
        }
        this.searchModal = false;
        this.nextLevelValue = "";
      }
      return false;
    },
    handleGoMenu(item) {
      this.searchModal = false
      const currentPath = this.$router.currentRoute.fullPath;
      switch (item.path) {
        case '/vistor/register-gz':
          if (currentPath != item.path) {
            this.$router.push(item.path)
          }
          break;
        case '/ZsCenter':
          if (!localStorage.getItem('userIdentity') || localStorage.getItem('userIdentity') === 'visitor') {
            this.$message.error(this.$t('h.headSearch.PleaseLoginAsExhibitor'))
            return false
          }
          if (currentPath != item.path) {
            this.$router.push(item.path)
          }
          break;
        case '/vistor/center':
          if (!localStorage.getItem('userIdentity') || localStorage.getItem('userIdentity') === 'zs') {
            this.$message.error(this.$t('h.headSearch.PleaseLoginAsAudience'))
            return false
          }
          if (currentPath != item.path) {
            this.$router.push(item.path)
          }
          break;
        default:
          if (currentPath != item.path) {
            this.$router.push(item.path)
          }
          break;
      }
    },
    handleClickSearch(search) {
      this.searchModal = false
      this.$router.push({
        path: "/search",
        query: {
          globalSearch: search
        }
      })
      // localStorage.setItem('queryKey', "产品")
      // this.$router.push('/product/supplier?search=' + search)
      // EventBus.$emit('handleProductSearch', item);
    },
    menuMouseOver(index) {
      if (this.searchModal) {
        this.showHoverDiv = false
        return false;
      }
      if (index === 0) {
        this.showHoverDiv = false
        return false;
      }
      this.showHoverDiv = true
    },
    menuMouseOut() {
      this.showHoverDiv = false
    },
    searchModalBtn() {
      this.showHoverDiv = false
      this.searchModal = true
    },
    changeLanguage(value) {
      let language = localStorage.getItem('lang')
      if (value === localStorage.getItem('lang')) {
        return false;
      }
      if (value === '日本語') {
        window.open('https://www.wirechina.net/cn/index.jp.html', {target: "_blank"})
        this.language = localStorage.getItem('lang')
        return false
      } else if (value === '한국어') {
        window.open('https://www.wirechina.net/cn/index.kr.html', {target: "_blank"})
        this.language = localStorage.getItem('lang')
        return false
      } else if (value === 'ไทย') {
        window.open('https://www.wirechina.net/cn/index.thai.html', {target: "_blank"})
        this.language = localStorage.getItem('lang')
        return false
      }
      message.loading(this.$t('h.languageChangeLoading'), 1).then(() => {
        if (language === "EN") {
          localStorage.setItem("lang", "ZH");
          this.$i18n.locale = "zh";
          location.reload();
          this.language = "ZH";
        } else {
          localStorage.setItem("lang", "EN");
          this.$i18n.locale = "en";
          location.reload();
          this.language = "EN";
        }
      });
    },
    customMenu(value) {
      const currentPath = this.$router.currentRoute.fullPath;
      switch (value) {
        case 'zs':
          if (currentPath !== '/zwApply') {
            this.$router.push('/zwApply')
          } else {
            location.reload()
          }
          break;
        case 'gz':
          if (currentPath !== '/vistor/register') {
            this.$router.push('/vistor/register')
          } else {
            location.reload()
          }
          break;
      }
    },
    titleClick(index) {
      if (index !== 0) {
        if (index === 5) {
          const currentPath = this.$router.currentRoute.fullPath;
          if (currentPath !== '/product/supplier') {
            this.$router.push('/product/supplier')
            this.initMenu(5)
          } else {
            location.reload()
          }
        }
        return false;
      }
      this.goHomeBtn()
    },
    goHomeBtn() {
      this.initMenu(0)
      this.$router.push('/')
    },
    initMenu(index) {
      this.menu.forEach((item) => {
        item.select = false
      })
      this.menu[index].select = true
    },
    itemClick(path, index, queryKey) {
      if (path === '/product/release') {
    //             if (localStorage.getItem('token')) {
    //       if (localStorage.getItem('userIdentity') === 'zs') {
    //         this.$router.push('/zsCenter')
    //         localStorage.setItem('change-a-menu', '发布采购需求')
    //       } else {
    //         this.$router.push('/vistor/center')
    //         localStorage.setItem('change-a-menu', '发布采购需求')
    //       }
    //     } else {
		  // this.$router.push('/vistor/login')
    //       this.$message.warning(this.$t('h.custom.PleaseLogin'))
    //     }
        window.open('https://qywx.wjx.cn/vm/rpYvq2P.aspx', '_blank')
        return false;
      }
      if (!path) {
        this.$message.error(this.$t('h.headSearch.NotOpenYet'))
        return false;
      }
      this.initMenu(index)
      const currentPath = this.$router.currentRoute.fullPath;
      if (queryKey) {
        localStorage.setItem('queryKey', queryKey)
      }
      if (currentPath !== path) {
        if (path === '/zsLogin') {
          if (localStorage.getItem('userIdentity') === 'visitor') {
            this.$message.error(this.$t('h.headSearch.PleaseLogoutOfAudienceLoginFirst'))
            return false
          }
        } else if (path === '/vistor/login') {
          if (localStorage.getItem('userIdentity') === 'zs') {
            this.$message.error(this.$t('h.headSearch.PleaseLogoutOfExhibitorLoginFirst'))
            return false
          }
        }
        this.$router.push(path)
      } else {
        // location.reload()
      }
    },
    loginBtn(value) {
      switch (value) {
        case 'zs':
          if (localStorage.getItem('userIdentity') === 'visitor') {
            this.$message.error(this.$t('h.headSearch.PleaseLogoutOfAudienceLoginFirst'))
            return false
          }
          if (!localStorage.getItem('token')) {
            this.$router.push('/zsLogin')
            return false
          }
          this.$router.push('/zsCenter')
          break;
        case 'gz':
          if (localStorage.getItem('userIdentity') === 'zs') {
            this.$message.error(this.$t('h.headSearch.PleaseLogoutOfExhibitorLoginFirst'))
            return false
          }
          if (!localStorage.getItem('token')) {
            this.$router.push('/vistor/login')
            return false
          }
          this.$router.push('/vistor/center')
          break;
		// 获取当前语言
   //    const lang = this.$i18n.locale || localStorage.getItem('lang') || 'ZH';
   //    const isChinese = lang === 'ZH' || lang === 'zh';
	  
	  //       if (!localStorage.getItem('token')) {
	  //         // 未登录：根据语言跳转不同登录页
	  //         const loginUrl = isChinese 
	  //           ? 'https://oa.tonggao.info/CN/Customer/Front?projectCode=tg8dd8cacf7cf962a'  // 中文登录链接
	  //           : 'https://oa.tonggao.info/EN/Customer/Front?projectCode=tg8dd8cacf7cf962a&source='; // 英文登录链接
	  //         window.open(loginUrl, '_blank');
	  //       } else {
	  //         // 已登录：根据语言跳转不同中心页
	  //         const centerUrl = isChinese
	  //           ? 'https://oa.tonggao.info/CN/Customer/Front?projectCode=tg8dd8cacf7cf962a'  // 中文中心链接
	  //           : 'https://oa.tonggao.info/EN/Customer/Front?projectCode=tg8dd8cacf7cf962a&source='; // 英文中心链接
	  //         window.open(centerUrl, '_blank');
	  //       }
	  //       break;

      }
    }
  }
};
</script>
<style scoped lang="scss">
.menuTitle {
  font-weight: bold;
  color: #444444;
  font-size: 18px;
  cursor: pointer;
}

.menuTitle:hover {
  color: #d7000F;
}

.title {
  font-size: 20px;
  color: #444444;
  font-weight: bold;
  line-height: 24px;
}

.subTitle {
  font-size: 16px;
  color: #444444;
  margin-top: 6px;
  cursor: pointer;
  font-weight: 500;
}

.subTitle:hover {
  color: #3DA5FF;
}

.prodTitle {
  font-size: 20px;
  color: #444444;
  font-weight: bold;
  line-height: 24px;
}

.prodTitle:hover {
  color: #3DA5FF;
}

</style>
